import React from 'react';
import { Item } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/views/item.less';

export default Item;
